import Request from '@/models/Request'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    requestDetails: null
  },

  mutations: {
    setRequestList(state, requests) {
      each(requests, request => {
        const exist = find(state.list, { id: request.id })
        if (!exist) {
          state.list.push(new Request(request))
        }
      })
    },

    clearRequestList(state) {
      state.list = []
    },

    setRequestListMeta(state, meta) {
      state.listMeta = meta
    },

    setRequestDetails(state, request) {
      if (request instanceof Request) {
        state.requestDetails = request
      } else {
        state.requestDetails = new Request(request)
      }
    },

    clearRequestDetails(state) {
      state.requestDetails = null
    },

    setTemplates(state, payload) {
      state.templates = payload
    },

    addCategory(state, payload) {
      state.templates.push({ name: payload })
    }
  },

  getters: {
    requestDetails(state) {
      return state.requestDetails
    }
  },

  actions: {
    async getRequests({ commit }, params) {
      const query = Request.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      if (params.sort) {
        query.orderBy(params.sort)
      }

      if (params.searchDate) {
        query.where('searchDate', params.searchDate)
      }

      if (params.template) {
        query.where('template', params.template)
      }

      query.where('status', params.status)

      const res = await query.params({ limit: 20 }).get()

      commit('setRequestList', res.data)
      commit('setRequestListMeta', res.meta)
    },

    async getRequestDetails({ commit }, id) {
      const { data } = await Api.get(`admin/files/${id}`)
      commit('setRequestDetails', data.data)
    }
  }
}
